<div class="fuzzy-logic-wrapper">
  <div class="fuzzy-logic-content p-3">
    <form [formGroup]="configForm">
      <!-- Sección 1: nombre de la configuración y eliminar -->
      <div class="mb-2">
        <input
          type="search"
          class="form-control"
          formControlName="name"
          [class.is-invalid]="
            configForm.get('name')?.invalid &&
            configForm.get('name')?.touched
          "
          placeholder="{{ 'fuzzy-logic-config.name-placeholder' | translate }}"
        />
        <span
          class="text-danger"
          *ngIf="
            configForm.get('name')?.invalid &&
            configForm.get('name')?.touched
          "
        >
          {{ "admin.admins.error-name" | translate }}
        </span>
        <small class="text-danger c-pointer d-block mt-1" (click)="deleteConfig()">
          {{ "fuzzy-logic-config.delete-config" | translate }}
        </small>
      </div>

      <!-- Sección 2: texto descriptivo -->
      <p class="fuzzy-description">
        {{ "fuzzy-logic-config.description" | translate }}
      </p>

      <!-- Sección 3: Ajuste -->
      <ng-container *ngIf="view_ajust">
        <h3 class="fuzzy-section-title">{{ "view-fuzzy-logic.adjustment" | translate }}</h3>

        <nav class="fuzzy-tabs">
          <a
            *ngFor="let item of config"
            class="fuzzy-tab-item"
            [class.active]="config_selected === item.title"
            (click)="config_selected = item.title"
          >
            {{item.title}}
          </a>
        </nav>

        <div class="mt-3" formArrayName="configurations">
          <div
            *ngFor="let config of configurations.controls; let i = index"
            [formGroupName]="i"
            [ngClass]="{'d-none': config_selected !== config.get('title').value}"
          >
            <!-- Nivel: etiqueta y sus 3 valores; en angosto la etiqueta va arriba -->
            <div class="fuzzy-level" *ngFor="let level of levelKeys">
              <div class="fuzzy-level__grid" [formGroupName]="level">
                <label class="fuzzy-level__label m-0">{{ viewTitle(level) }}:</label>
                <div *ngFor="let subLevel of subLevelKeys" class="fuzzy-level__field">
                  <input
                    type="number"
                    [formControlName]="subLevel"
                    class="form-control"
                    [class.is-invalid]="
                      config.get(level)?.get(subLevel)?.invalid &&
                      config.get(level)?.get(subLevel)?.touched
                    "
                  />
                  <div class="d-flex gap-6">
                    <span>{{ viewTitle(subLevel) }}</span>
                    <div
                      class="text-danger d-block"
                      style="font-size: 11px"
                      *ngIf="
                      config.get(level)?.get(subLevel)?.invalid &&
                      config.get(level)?.get(subLevel)?.touched
                    "
                    >
                      {{ "fuzzy-logic-config.required" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <button
            (click)="setConfig()"
            type="button"
            [disabled]="configForm.invalid || loading_petition"
            class="btn btn-success px-4 fuzzy-save-btn"
          >
            <app-spinner [smallLoader]="true" [spinnerColor]="'text-white'" *ngIf="loading_petition">
            </app-spinner>
            <span class="m-0" *ngIf="!loading_petition"> {{ "fuzzy-logic-config.save-changes" | translate }} </span>
          </button>
        </div>
      </ng-container>
    </form>

    <ng-container *ngIf="!view_ajust">
      <h3 class="fuzzy-section-title">{{ "fuzzy-logic-config.test" | translate }}</h3>
      <p class="fuzzy-description">
        {{ "fuzzy-logic-config.test-description" | translate }}
      </p>

      <div class="fuzzy-test-card">
        <form [formGroup]="testForm">
          <div class="floating-label">
            <input
              type="number"
              class="form-control"
              formControlName="temperature"
              placeholder=" "
              [class.is-invalid]="
                testForm.get('temperature')?.invalid &&
                testForm.get('temperature')?.touched
              "
            />
            <span>{{ "fuzzy-logic-config.temperature-celsius" | translate }}</span>
          </div>
          <span
            class="text-danger"
            *ngIf="
              testForm.get('temperature')?.invalid &&
              testForm.get('temperature')?.touched
            "
          >
            {{ "fuzzy-logic-config.temperature-required" | translate }}
          </span>

          <div class="floating-label mt-3">
            <input
              type="number"
              class="form-control"
              formControlName="oxygen"
              placeholder=" "
              [class.is-invalid]="
                testForm.get('oxygen')?.invalid &&
                testForm.get('oxygen')?.touched
              "
            />
            <span>{{ "alerts.parametry.oxygen" | translate }}</span>
          </div>
          <span
            class="text-danger"
            *ngIf="
              testForm.get('oxygen')?.invalid &&
              testForm.get('oxygen')?.touched
            "
          >
            {{ "fuzzy-logic-config.oxygen-required" | translate }}
          </span>

          <div class="floating-label mt-3">
            <input type="number" class="form-control" formControlName="feeding_kgs" placeholder=" " />
            <span>{{ "fuzzy-logic-config.feeding-kgs" | translate }}</span>
          </div>

          <div class="d-flex justify-content-center mt-3">
            <button
              class="btn btn-secondary px-4 fuzzy-save-btn"
              type="button"
              [disabled]="configForm.invalid || testForm.invalid"
              (click)="testConfig()"
            >
              {{ "fuzzy-logic-config.test-button" | translate }}
            </button>
          </div>
        </form>

        <div class="fuzzy-test-result" *ngIf="resultTest">
          <div class="row justify-content-center align-items-center">
            <div class="col-12 col-md-6 text-center">
              <b>{{resultTest.new_feeding_kgs.toFixed(2)}} Kg.</b>
              <p class="m-0">{{ "fuzzy-logic-config.kg-to-send" | translate }}</p>
            </div>
            <div class="col-12 col-md-6 text-center">
              <b>{{resultTest.modifier.toFixed(2)}}%</b>
              <p class="m-0">{{ "view-fuzzy-logic.percentage" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Menú inferior -->
  <nav class="fuzzy-bottom-menu">
    <a class="fuzzy-tab-item" [class.active]="view_ajust" (click)="view_ajust = true">
      {{ "offsidebar.config.settings" | translate }}
    </a>
    <a class="fuzzy-tab-item" [class.active]="!view_ajust" (click)="view_ajust = false">
      {{ "fuzzy-logic-config.test" | translate }}
    </a>
  </nav>
</div>
